import { render } from "./Show.vue?vue&type=template&id=4fbe961c&scoped=true"
import script from "./Show.vue?vue&type=script&lang=js"
export * from "./Show.vue?vue&type=script&lang=js"

import "./Show.vue?vue&type=style&index=0&id=4fbe961c&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fbe961c"],['__file',"resources/js/pages/homeWorks/Show.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4fbe961c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4fbe961c', __exports__)) {
    console.log('reload')
    api.reload('4fbe961c', __exports__)
  }
  
  module.hot.accept("./Show.vue?vue&type=template&id=4fbe961c&scoped=true", () => {
    console.log('re-render')
    api.rerender('4fbe961c', render)
  })

}


export default __exports__